var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m12 19-7-7 7-7","key":0}),React.createElement("path",{"d":"M19 12H5","key":1})]);
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-arrow-left-icon lucide-arrow-left"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
